import React from 'react';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

const styling = xcss({
	borderLeft: `${token('border.width.selected')} solid ${token('color.border')}`,
	display: 'inline-block',
	width: '1px',
	height: '16px',
	marginBlock: 'space.0',
	marginRight: 'space.050',
	marginLeft: 'space.100',
	alignSelf: 'center',
});

export const StyledBorder = (): React.JSX.Element => <Box testId="vertical-line" xcss={styling} />;
